import { render, staticRenderFns } from "./create-qr-code.vue?vue&type=template&id=35858dd2&scoped=true&"
import script from "./create-qr-code.vue?vue&type=script&lang=js&"
export * from "./create-qr-code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35858dd2",
  null
  
)

export default component.exports